import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AppLayout from '@layouts/app-layout';
import AuthPage from '@pages/auth';
import LoginPage from '@pages/login';
import PasswordResetPage from '@pages/password-reset';
import ProfilePage from '@pages/profile';
import MiddlewarePage from '@pages/middleware';
import './root-layout.scss';
var RootLayout = function () {
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: "/auth" },
            React.createElement(AuthPage, null)),
        React.createElement(Route, { exact: true, path: "/login" },
            React.createElement(LoginPage, null)),
        React.createElement(Route, { exact: true, path: "/password_reset" },
            React.createElement(PasswordResetPage, null)),
        React.createElement(Route, { path: "/middleware" },
            React.createElement(MiddlewarePage, null)),
        React.createElement(Route, { exact: true, path: "/profile" },
            React.createElement(ProfilePage, null)),
        React.createElement(Route, { path: "/*" },
            React.createElement(AppLayout, null))));
};
export default React.memo(RootLayout);
